import React from 'react';
import { Col } from 'reactstrap';
const InvCol = (props) => {
  return(
    <Col md={props.size} xs={props.sixeXs} className={props.customClass ? props.customClass : null }>
      <h6 className="theta">{props.value}</h6>
    </Col>
  )
}
export default InvCol;
